module.exports = __webpack_public_path__ + "static/media/blob-2.dfc43b32.svg";